export function getLocationName(referral) {
  return referral?.person?.is_patient === false
    ? referral.person.location.name
    : ''
}
